import React, { useState, useEffect } from "react";
import styles from "./DataTable.module.css";
// import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

export default function DataTable({
    title,
    columns,
    data,
    onRefresh,
    showSearch = false,
    showRefresh = false,
    sortBy,
    sortOrder,
    onSort
}) {
    const [search, setSearch] = useState("");

    if (!data || !Array.isArray(data)) {
        return <div>No data received</div>;
    }

    const hasHeaderContent = title || showSearch || showRefresh;

    return (
        <div className={styles.container}>
            {/* Header */}
            {hasHeaderContent && (
                <div className={styles.header}>
                    {title && <h2>{title}</h2>}
                    <div className={styles.headerActions}>
                        {showRefresh && (
                            <button className={styles.refreshBtn} onClick={onRefresh}>
                                🔄 Refresh
                            </button>
                        )}
                        {showSearch && (
                            <input
                                type="text"
                                placeholder="🔍 Search..."
                                className={styles.searchInput}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        )}
                    </div>
                </div>
            )}

            {/* Table */}
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    style={{ width: col.width, cursor: col.sortable ? 'pointer' : 'default' }}
                                    onClick={() => col.sortable && onSort && onSort(col.key)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        {col.label}
                                        {col.sortable && (
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                {sortBy === col.key ? (
                                                    sortOrder === 'ASC' ? (
                                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M12 19V5" />
                                                            <path d="M5 12l7-7 7 7" />
                                                        </svg>
                                                    ) : (
                                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M12 5v14" />
                                                            <path d="M19 12l-7 7-7-7" />
                                                        </svg>
                                                    )
                                                ) : (
                                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.3 }}>
                                                        <path d="M7 15l5 5 5-5" />
                                                        <path d="M7 9l5-5 5 5" />
                                                    </svg>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, idx) => (
                                <tr key={idx}>
                                    {columns.map((col) => (
                                        <td
                                            key={col.key}
                                            style={{
                                                width: col.width,
                                                maxWidth: col.width,
                                                whiteSpace: "normal",     // allow wrapping
                                                wordWrap: "break-word",   // break long words
                                            }}
                                        >
                                            {col.render ? col.render(row[col.key], row) : row[col.key]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className={styles.emptyState}>
                                    No records found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
